module.exports = __webpack_public_path__ + "img/scene3-4.356bb211.jpg";